export const COMPLETED_APPOINTMENT_COLOR = "#9CA3AF";
export const appointmentIsCompleted = appointment => appointment?.status === "completed" || appointment?.checkout_status === "completed";
export const calendarAppointmentColor = (appointment, originColor) => appointmentIsCompleted(appointment) ? COMPLETED_APPOINTMENT_COLOR : originColor;
